// skipcq: JS-W1028
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import SnapshotBeerRow from './SnapshotBeerRow';

function SnapshotTableHead() {
  return (
    <TableHead>
      <TableRow>
        <TableCell>Status</TableCell>
        <TableCell>Name</TableCell>
        <TableCell>Style</TableCell>
        <TableCell>ABV</TableCell>
        <TableCell>Description</TableCell>
        <TableCell>Issues</TableCell>
      </TableRow>
    </TableHead>
  );
}

export default function BeerIngestionSnapshotTable({ beers }) {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small" stickyHeader aria-label="Extracted beers">
        <SnapshotTableHead />
        <TableBody>
          {beers.map((beer) => (
            <SnapshotBeerRow key={beer.index} beer={beer} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

BeerIngestionSnapshotTable.propTypes = {
  beers: PropTypes.arrayOf(PropTypes.object).isRequired,
};
